import { createFileRoute } from "@tanstack/react-router";

import Songs from "@/features/songs/Songs";
import SideNavLayout from "@/layouts/SideNavLayout";
import { SongsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/songs/")({
  component: () => (
    <SideNavLayout menu={<SongsMenu />}>
      <Songs />
    </SideNavLayout>
  ),
});
